export function createVHtmlDirective(sanitizeHtml, customModes = {}) {
  const sanitizeModes = {
    native: (html) => html,
    strict: (html) => sanitizeHtml(html),
    ...Object.fromEntries(
      Object.entries(customModes || {}).map(([key, modeConfig]) => [
        key,
        (html) => sanitizeHtml(html, modeConfig)
      ])
    )
  };
  function getSanitizeMode(binding) {
    if (binding.arg && binding.arg in sanitizeModes) {
      return binding.arg;
    }
    return "strict";
  }
  function applySanitization(el, binding) {
    const mode = getSanitizeMode(binding);
    el.innerHTML = binding.value ? sanitizeModes[mode](binding.value) : "";
  }
  return {
    getSSRProps(binding) {
      return {
        innerHTML: binding.value ? sanitizeModes[getSanitizeMode(binding)](binding.value) : ""
      };
    },
    created: applySanitization,
    updated: applySanitization
  };
}
